import React from "react";

/**Import core component (variable)*/
import Spinner from "../../core/Spinner";

export const DEMO = props => {
  return <Spinner {...props} />;
};
